// Keyboard and screen-reader support for elements that act as buttons but
// cannot be a <button> without restyling: expandable table rows, heatmap
// cells, promotion pieces.

const NESTED_CONTROLS = "a[href], button, input, select, textarea, label, [role='button']";

// True when the event started on a control nested inside the clickable
// element (a checkbox or link in an expandable row). That control handles
// the event itself, so the row should not toggle as well.
const fromNestedControl = (event) => {
    const control = event.target?.closest?.(NESTED_CONTROLS);
    return control != null && control !== event.currentTarget && event.currentTarget.contains(control);
};

/**
 * Props that make a non-button element behave like a button: announced as a
 * button, reachable with Tab, activated by click, Enter or Space.
 *
 *     <div className="ut-row" {...clickableProps(() => toggle(id))} />
 *
 * @param {(event: Event) => void} onActivate
 */
export const clickableProps = (onActivate) => ({
    role: "button",
    tabIndex: 0,
    onClick: (event) => {
        if (fromNestedControl(event)) return;
        onActivate(event);
    },
    onKeyDown: (event) => {
        if (event.key !== "Enter" && event.key !== " ") return;
        if (fromNestedControl(event)) return;
        event.preventDefault();
        onActivate(event);
    },
});
